import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoEtapaObra'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllByEmpreedimentoid = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByEmpreendimentoId/${id}`, data, config)
const GetTotalPercenByEmpreendimento = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetTotalPercenByEmpreendimento/${id}`, data, config)
const SaveEmpreendimentoEtapaObra = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SaveEmpreendimentoEtapaObra`, data, config)
const SalvarLista = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/SalvarLista`, data, config)

const WorkStageEnterpriseRepository = {
  GetAllByEmpreedimentoid,
  SalvarLista,
  SaveEmpreendimentoEtapaObra,
  GetTotalPercenByEmpreendimento

}

export default WorkStageEnterpriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/workstageenterprise.js